'use client'

import {
  type TextSize,
  fontSizeMap,
  themeTextColorMap,
} from '@mntn-dev/ui-theme'
import { useMemo } from 'react'
import { createContext } from '../../utils/context.ts'

type DataListVariant = 'default' | 'subtle' | 'inverted'

type UseDataListProps = {
  fontSize?: TextSize
  variant?: DataListVariant
}

const titleColorMap: Record<DataListVariant, string> = {
  default: themeTextColorMap.secondary,
  subtle: themeTextColorMap.tertiary,
  inverted: themeTextColorMap.primary,
}

const descriptionColorMap: Record<DataListVariant, string> = {
  default: themeTextColorMap.primary,
  subtle: themeTextColorMap.secondary,
  inverted: themeTextColorMap.secondary,
}

const useDataList = ({
  fontSize = 'base',
  variant = 'default',
}: UseDataListProps) => {
  const titleColorClassName = useMemo(() => titleColorMap[variant], [variant])
  const descriptionColorClassName = useMemo(
    () => descriptionColorMap[variant],
    [variant]
  )
  const fontSizeClassName = useMemo(() => fontSizeMap[fontSize], [fontSize])

  return {
    descriptionColorClassName,
    fontSize,
    fontSizeClassName,
    titleColorClassName,
    variant,
  }
}

const [DataListProvider, useDataListContext] = createContext<
  ReturnType<typeof useDataList>
>({ name: 'DataListContext' })

export {
  DataListProvider,
  useDataListContext,
  useDataList,
  type DataListVariant,
  type UseDataListProps,
}
